import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter, Youtube } from "lucide-react";

const COLUMNS = [
  {
    title: "TRIFIT",
    links: [
      { label: "Home", to: "/" },
      { label: "The Science", to: "/science" },
      { label: "About Us", to: "/about" },
      { label: "Trifit.life", to: "/transformation-kit" },
    ],
  },
  {
    title: "PRODUCTS / PLATFORMS",
    links: [
      { label: "TriKarma Band", to: "/trifit-xps" },
      { label: "Trifit XPS", to: "/trifit-xps" },
      { label: "Trifinity", to: "/trifinity" },
    ],
  },
  {
    title: "ACCESS",
    links: [
      { label: "Visit the Trifit Store", to: "#" },
      { label: "Get it on Amazon", to: "#" },
      { label: "Download the App", to: "#" },
    ],
  },
  {
    title: "LEGAL",
    links: [
      { label: "Privacy Policy", to: "#" },
      { label: "Terms & Conditions", to: "#" },
      { label: "Cookie Policy", to: "#" },
      { label: "Disclaimer", to: "#" },
      { label: "Refund Policy", to: "#" },
    ],
  },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram" },
  { icon: Twitter, label: "Twitter" },
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Youtube, label: "YouTube" },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative z-10 border-t border-line/60 bg-ink"
  >
    <div className="mx-auto max-w-[1600px] px-6 py-20 md:px-12 md:py-28">
      <div className="grid gap-16 md:grid-cols-12">
        <div className="md:col-span-4">
          <p className="font-display text-2xl font-light tracking-[0.2em] text-white">
            TRIFIT
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-ash">
            Personal intelligence, built around you.
          </p>
          <p className="mt-6 font-mono text-[10px] tracking-[0.18em] text-ash">
            AN IIT GUWAHATI INCUBATED COMPANY
          </p>
          <div className="mt-8 flex gap-5">
            {SOCIALS.map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="text-ash transition-colors duration-300 hover:text-white"
              >
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.2em] text-ash">
              {col.title}
            </p>
            <ul className="mt-6 space-y-3.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-fog/80 transition-colors duration-300 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-20 border-t border-line/50 pt-10">
        <p
          data-testid="footer-disclaimer"
          className="max-w-4xl text-[11px] leading-relaxed text-ash/80"
        >
          Trifit Intelligence uses statistical and machine-learning models.
          Predictions and recommendations may be uncertain or incorrect.
          Physiological, behavioural and environmental information may be used
          to generate them. Trifit is not a replacement for appropriate medical
          care; significant health-related decisions should be discussed with a
          qualified healthcare professional where applicable. Some imagery and
          text on this website may be AI-created or AI-enhanced.
        </p>
      </div>

      <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-line/50 pt-8 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] tracking-[0.18em] text-ash">
          © 2026 TRIFIT
        </p>
        <div className="flex gap-6">
          {["Privacy", "Terms", "Cookies"].map((l) => (
            <a
              key={l}
              href="#"
              data-testid={`footer-utility-${l.toLowerCase()}`}
              className="font-mono text-[10px] tracking-[0.18em] text-ash transition-colors duration-300 hover:text-fog"
            >
              {l.toUpperCase()}
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
